/**
 * Collection final request prep recommendation API permissions (design §12).
 */

export const COLLECTION_FINAL_REQUEST_PREP_READ_PERMISSION =
  'collection_final_request_prep:read' as const;
export const COLLECTION_FINAL_REQUEST_PREP_EVALUATE_PERMISSION =
  'collection_final_request_prep:evaluate' as const;
export const COLLECTION_FINAL_REQUEST_PREP_DISMISS_PERMISSION =
  'collection_final_request_prep:dismiss' as const;
export const COLLECTION_FINAL_REQUEST_PREP_APPROVE_PERMISSION =
  'collection_final_request_prep:approve' as const;
export const COLLECTION_FINAL_REQUEST_PREP_DEFER_PERMISSION =
  'collection_final_request_prep:defer' as const;

/** Bounded V1 read fallback for operators with AR collection surface access. */
export const COLLECTION_FINAL_REQUEST_PREP_READ_FALLBACK_PERMISSION = 'ar_collection:read' as const;

export const COLLECTION_FINAL_REQUEST_PREP_PERMISSIONS = [
  COLLECTION_FINAL_REQUEST_PREP_READ_PERMISSION,
  COLLECTION_FINAL_REQUEST_PREP_EVALUATE_PERMISSION,
  COLLECTION_FINAL_REQUEST_PREP_DISMISS_PERMISSION,
  COLLECTION_FINAL_REQUEST_PREP_APPROVE_PERMISSION,
  COLLECTION_FINAL_REQUEST_PREP_DEFER_PERMISSION,
] as const;

export type CollectionFinalRequestPrepPermission =
  (typeof COLLECTION_FINAL_REQUEST_PREP_PERMISSIONS)[number];

export function isCollectionFinalRequestPrepPermission(
  permission: string
): permission is CollectionFinalRequestPrepPermission {
  return (COLLECTION_FINAL_REQUEST_PREP_PERMISSIONS as readonly string[]).includes(permission);
}
